import { Home, Heart, UserCircle2, Banknote } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { cn } from '@/lib/utils';

export function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { path: '/', label: 'الرئيسية', icon: Home },
    { path: '/cashback', label: 'كاش باك', icon: Banknote },
    { path: '/favorites', label: 'المفضلة', icon: Heart },
    { path: '/account', label: 'حسابي', icon: UserCircle2 },
  ];

  // Mark account tab as active for account page only
  const isAccountActive =
    location.pathname === '/account' ||
    location.pathname.startsWith('/account/');

  // Hide on coupon detail page only
  if (location.pathname.startsWith('/coupon/')) {
    return null;
  }

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-border h-20 pb-safe">
      <div className="flex items-stretch justify-around h-full pt-[0.9rem]">
        {navItems.map((item) => {
          const isActive =
            item.path === '/account'
              ? isAccountActive
              : item.path === '/cashback'
                ? location.pathname === '/cashback' || location.pathname.startsWith('/cashback/')
              : location.pathname === item.path;
          const Icon = item.icon;
          
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={cn(
                "flex flex-col items-center justify-center text-center flex-1 h-full gap-1 transition-colors relative",
                isActive 
                  ? "text-primary" 
                  : "text-muted-foreground"
              )}
            >
              <div className="relative">
                <Icon 
                  className="w-6 h-6" 
                  strokeWidth={isActive ? 2.5 : 2} 
                />
                {item.badge && (
                  <span className="absolute -top-1.5 -right-2 min-w-[18px] h-[18px] bg-destructive text-destructive-foreground text-[10px] font-bold rounded-full flex items-center justify-center px-1">
                    {item.badge}
                  </span>
                )}
              </div>
              <span className={cn(
                "text-xs",
                isActive ? "font-semibold" : "font-normal"
              )}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
